import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TypeLocalProfileLayout from './TypeLocalProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import TypeLocalService from '../../services/TypeLocalService';

const ViewTypeLocal = ({ onClick }) => {
	const { id } = useParams();
	const [typeLocal, setTypeLocal] = useState(null); // Changed this from "eleve" to "TypeLocal"
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');

	useEffect(() => {
		Promise.all([TypeLocalService.getTypeLocal(id)]).then(([typeLocalData]) => {
			// Added "eleveData" to unpack second promise result
			setTypeLocal(typeLocalData.data);

			if (typeLocalData && typeLocalData.data) {
				const TypeLocalRelation = typeLocalData.data.type;
			}
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const typeLocalData = new FormData();

				// Add all your form data to the FormData
				typeLocalData.append('type', form.type.value);

				// Call the EleveService to create the eleve
				const response = await TypeLocalService.updateTypeLocal(
					id,
					typeLocalData
				);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations du type de local',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<TypeLocalProfileLayout>
			{typeLocal && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}

								<Row>
									<Col xs={12} className="mb-3">
										{/* type et description  */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="type">
														Type de Local <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="type"
														type="text"
														placeholder="Saisir le type du TypeLocal"
														id="type"
														required
														isInvalid={!!feedbackMessages['type']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																type: e.target.value
																	? ''
																	: 'Le type est requis.'
															}));
														}}
														defaultValue={typeLocal.type}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['type']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</TypeLocalProfileLayout>
	);
};

export default ViewTypeLocal;
